import axios from 'axios';
import { loginService } from '../services/LoginService';

// Configure axios response interceptor to handle 401 errors globally
axios.interceptors.response.use(
  (response) => {
    // If the response is successful, return it as-is
    return response;
  },
  (error) => {
    // Handle error responses
    if (error.response) {
      const { status, config } = error.response;
      
      // If we get a 401 Unauthorized, redirect to login
      // Skip redirect for login/logout endpoints to avoid redirect loops
      const isLoginEndpoint = config?.url?.includes('/api/login') || 
                               config?.url?.includes('/api/logout') ||
                               config?.url?.includes('/api/password/forgot') ||
                               config?.url?.includes('/api/password/reset');
      
      if (status === 401 && !isLoginEndpoint) {
        // Clear token and user data
        loginService.removeToken();
        localStorage.removeItem('userProfile');
        
        // Redirect to login page only if we're not already there
        // Using window.location.href instead of navigate because
        // we're in an interceptor context outside React Router
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    
    // Return the error so it can be handled by the calling code
    return Promise.reject(error);
  }
);

export default axios;
